// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","votes":"_3xkhCLkmkiPtD5qSdSaDJm"};